import { useCallback, useState } from "react";
import { useLatestRequest } from "../../../hooks/useLatestRequest";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { getUserById } from "../api/users.api";
import type { UserItem } from "../types/user.types";

export interface UseGetUserByIdReturn {
  getUser: (id: string) => Promise<UserItem | undefined>;
  loading: boolean;
  error: string | null;
}

export function useGetUserById(): UseGetUserByIdReturn {
  const [error, setError] = useState<string | null>(null);
  const { run, loading } = useLatestRequest();
  const getUser = useCallback(
    async (id: string) => {
      setError(null);
      try {
        return await run((signal) => getUserById(id, signal));
      } catch (requestError: unknown) {
        setError(getApiErrorMessage(requestError, "Failed to load user"));
        throw requestError;
      }
    },
    [run],
  );
  return { getUser, loading, error };
}
